import { createContext } from 'react';

interface DataRefreshContextType {
  forceRefresh: () => void;
  refreshTrigger: number;
}

export const DataRefreshContext = createContext<DataRefreshContextType | undefined>(undefined);